export default "__VITE_ASSET__ZyGy1vbV__"